import { render, staticRenderFns } from "./CompletedProjects.vue?vue&type=template&id=fd42bd64&scoped=true"
import script from "./CompletedProjects.vue?vue&type=script&lang=js"
export * from "./CompletedProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd42bd64",
  null
  
)

export default component.exports